<template>
    <section>
        <nav class="services">
            <div v-for="(row, rowindex) in services" :key="rowindex" class="row" :class="{'last-row': rowindex == services.length -1}">
                <div v-for="(item, index) in row" :key="index" class="service-link-container" :class="{'slc-bordered': index != row.length -1, 'slc-bordered-mobile': index == row.length -1 && rowindex == 1 }">

                    <a :href="item.url" class="service-link" v-if="item.type == 'link'" :class="{'showed': showLinks, 'to-up': rowindex == 0, 'to-bottom': rowindex == 1}">
                        <img :src="require('../../assets/icons/' + item.icon)">
                        <span>{{item.text}}</span>
                    </a>

                    <router-link :to="item.url" class="service-link" v-if="item.type == 'route'" :class="{'showed': showLinks, 'to-up': rowindex == 0, 'to-bottom': rowindex == 1}">
                        <img :src="require('../../assets/icons/' + item.icon)">
                        <span>{{item.text}}</span>
                    </router-link>

                </div>
            </div>
        </nav>
    </section>
</template>

<script>
    export default {
        name: "Services",
        data(){
            return {
                showLinks: false,
                services: [
                    [
                        {
                            text: "расписание занятий",
                            icon: "raspzan.png",
                            type: "route",
                            //url: "http://schedule.uni-dubna.ru/"
                            url: "/schedule"
                        },
                        {
                            text: "Система управления обучением",
                            icon: "lms.png",
                            type: "link",
                            url: "https://lms.uni-dubna.ru"
                        },
                        {
                            text: "Инструкции",
                            icon: "manual.png",
                            type: "route",
                            url: "/manual"
                        },
                        {
                            text: "Горячая линия",
                            icon: "sup.png",
                            type: "route",
                            url: "/help"
                        }
                    ],
                    [
                        {
                            text: "МООК",
                            icon: "mook.png",
                            type: "route",
                            url: "/oor"
                        },
                        {
                            text: "Личный кабинет",
                            icon: "lk.png",
                            type: "link",
                            url: "https://www.uni-dubna.ru/Account/Login"
                        },
                        {
                            text: "Библиотеки",
                            icon: "libre.png",
                            type: "link",
                            url: "https://lib.uni-dubna.ru"
                        },
                        {
                            text: "Дополнительное образование",
                            icon: "dpo.png",
                            type: "route",
                            url: "/app"
                        }

                    ]
                ]
            }
        },
        mounted() {
            setTimeout(()=>{this.showLinks = true}, 500);
        }
    }
</script>

<style scoped>
    .services{
        display: flex;
        flex-direction: column;
        background-color: #18224b;
    }

    .row{
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 15px;
    }

    .last-row{
        margin-bottom: 15px;
    }

    .service-link-container{
        max-width: 300px;
        margin: 0;
    }

    .slc-bordered{
        border-right: 1px solid #EEEEEE;
    }

    .service-link{
        width: 260px;
        height: 206px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
        box-sizing: border-box;
        margin: 0 20px;
        padding: 0 25px;
    }

    .to-bottom{
        transition: all .2s ease-in-out;
        transform: translate3d(0px, 30px, 0);
        opacity: 0;
    }

    .to-up{
        transition: all .2s ease-in-out;
        transform: translate3d(0px, -30px, 0);
        opacity: 0;
    }

    .showed{
        transform: translate3d(0px, 0, 0)!important;
        opacity: 1!important;
    }

    .service-link img{
        display: flex;
        width: 64px;
        height: 64px;
        margin-bottom: 30px;
    }

    .service-link span{
        color: #dc7d43;
        text-decoration: none;
        font-size: 18px;
        font-weight: 400;
        font-family: 'PT Sans' !important;
        text-transform: uppercase;
        line-height: 1.35;
    }

    @media (max-width: 1211px){
        .service-link{
            width: 200px;
            height: 206px;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            box-sizing: border-box;
            margin: 0 0px;
            padding: 0 25px;
        }
    }

    @media (max-width: 850px){
        .services{
            padding-top: 10px;
        }

        .row{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .slc-bordered{
            border-right: 0px solid #EEEEEE;
            border-bottom: 0px solid #EEEEEE;
            border-top: 1px solid #EEEEEE;
            padding-bottom: 10px;
            padding-top: 10px;
        }

        .slc-bordered-mobile{
            border-top: 1px solid #EEEEEE;
            padding-bottom: 10px;
            padding-bottom: 10px;
            padding-top: 10px;
        }

        .to-bottom{
            transition: all .2s ease-in-out;
            transform: translate3d(30px, 0px, 0);
            opacity: 0;
        }

        .to-up{
            transition: all .2s ease-in-out;
            transform: translate3d(-30px, 0px, 0);
            opacity: 0;
        }


    }

</style>
